function asObject(v) {
  if (!v || typeof v !== "object" || Array.isArray(v)) return null;
  return v;
}
function parseMoney(value) {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value !== "string") return void 0;
  const cleaned = value.replace(/[^0-9.-]/g, "");
  const n = Number.parseFloat(cleaned);
  return Number.isFinite(n) ? n : void 0;
}
function normalizeProductForFederated(raw) {
  const obj = asObject(raw);
  if (!obj) return null;
  const next = { ...obj };
  const price = parseMoney(obj.retailPrice ?? obj.price);
  if (price !== void 0) {
    next.retailPrice = price;
    next.price = price;
  }
  const reward = parseMoney(obj.totalRewardAmount);
  if (reward !== void 0) next.totalRewardAmount = reward;
  return next;
}
function normalizeProductsForFederated(products) {
  const out = [];
  for (const p of products) {
    const normalized = normalizeProductForFederated(p);
    if (normalized) out.push(normalized);
  }
  return out;
}
function normalizeProductForFeatured(raw) {
  const obj = asObject(raw);
  if (!obj) return null;
  const next = { ...obj };
  const price = parseMoney(obj.retailPrice ?? obj.price);
  if (price !== void 0) {
    next.retailPrice = price;
    next.price = price;
  }
  if (typeof obj.reviewRating === "number") next.reviewsRating = obj.reviewRating;
  if (typeof obj.reviewCount === "number") next.reviewsCount = obj.reviewCount;
  const reward = parseMoney(obj.totalRewardAmount);
  if (reward !== void 0) next.totalRewardAmount = reward;
  return next;
}
function mapVoiceWidgetToFederated(type, data) {
  const obj = asObject(data);
  if (!obj) return null;
  if (type === "data-widget-product-card") {
    const normalized = normalizeProductForFeatured(obj);
    if (!normalized) return null;
    return {
      widgetId: "featured-product",
      toolOutput: {
        product: normalized
      }
    };
  }
  if (type === "data-widget-comparison") {
    const products = obj.products;
    if (!Array.isArray(products) || products.length === 0) return null;
    const normalizedProducts = normalizeProductsForFederated(products);
    if (normalizedProducts.length === 0) return null;
    const attributes = obj.attributes;
    if (Array.isArray(attributes) && attributes.length > 0) {
      return {
        widgetId: "compare-products",
        toolOutput: {
          products: normalizedProducts,
          comparisonAttributes: attributes
        }
      };
    }
    return {
      widgetId: "product-carousels",
      toolOutput: {
        sections: [
          {
            title: "",
            products: normalizedProducts
          }
        ]
      }
    };
  }
  return null;
}
export {
  mapVoiceWidgetToFederated
};
//# sourceMappingURL=voiceToFederatedWidget.js.map
